import { DEFAULT_FOLDER_ID } from "@zapier/utils";
import { trpc } from "../trpc";

interface Input {
  folderId?: string;
}

/** Mutation hook that bulk-restores mixed asset ids and invalidates caches. */
export function useBulkRestoreAssets({ folderId }: Input) {
  const utils = trpc.useUtils();

  return trpc.asset.bulkRestore.useMutation({
    onSettled: () => {
      utils.table.search.invalidate();
      utils.canvas.search.invalidate();
      utils.zap.searchZaps.invalidate();
      utils.zap.storageZaps.invalidate();
      utils.zap.organizationZaps.invalidate();

      utils.asset.getHydratedFolderAssets.invalidate();

      if (folderId) {
        utils.asset.getHydratedFolderAssets.invalidate({
          folderId,
        });
      }

      utils.asset.getHydratedFolderAssets.invalidate({
        folderId: DEFAULT_FOLDER_ID,
      });

      // A restored favorite should reappear without waiting out staleTime.
      utils.userProperty.getHydratedFavoriteAssets.invalidate();
    },
  });
}
